import * as React from 'react';
import { PageProps } from 'gatsby';
import Layout from '../components/Layout';
import { EquationContainer } from '../components/Equations/EquationContainer';
import { ResistorDividerComponent } from '../components/Equations/ResistorDividerComponent';

export default function ResistorDividerPage(props: PageProps): JSX.Element {
  const pageTitle = 'Resistor Divider';

  return (
    <Layout location={props.location} title={pageTitle}>
      <EquationContainer>
        <ResistorDividerComponent />
      </EquationContainer>
    </Layout>
  );
}
